<template>
  <div>
    <common-dialog
      ref="dialog"
      width="800px"
      show-save-button
      title="添加运费明细"
      :in-dialog="inDialog"
      id-key="SupportId"
      :data="data"
      :form-rules="rules"
      @create-opened="onCreateOpened"
      :save-func="() => {}"
      :before-save="onBeforeSave"
      @closed="onClosed"
    >
      <template slot="form">
        <!-- <el-form-item label="区" prop="DistrictId">
          <el-select ref="district" size="mini" v-model="data.DistrictId" placeholder="请选择区">
            <template v-for="(x,key) in District">
              <el-option :key="key" :label="x.Name" :value="x.DistrictId" />
            </template>
          </el-select>
        </el-form-item>-->
        <el-row :gutter="10">
          <el-col :span="12">
            <div class="citys-head">区列表</div>
            <div class="citys-box m-scroll" style="height: 300px">
              <div class="item" v-for="(i, key) in Districts" :key="key">
                <span>{{ i.Name }}</span>
                <div class="btn-box" @click="select(i)">
                  <el-button
                    class="btn"
                    :disabled="i.check"
                    icon="el-icon-right"
                  ></el-button>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="citys-head">选中的区</div>
            <div class="citys-box m-scroll" style="height: 300px">
              <div class="item" v-for="(i, key) in Select" :key="key">
                <span>{{ i.Name }}</span>
                <span
                  @click="remove(i.Id, key)"
                  class="el-icon-error close-btn"
                ></span>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10" style="margin-top: 20px" v-if="Condition == '2'">
          <!-- <el-col :span="12">
            <el-form-item label="数量范围" class="is-required">
              <el-row>
                <el-col :span="11">
                  <el-form-item style="margin-bottom: 0;" prop="FirstQuantity">
                    <el-input size="mini" @blur="onBlur(data,'FirstQuantity')" @focus="onFocus(data,'FirstQuantity')" v-model="data.FirstQuantity" placeholder="输入数量"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2" style="line-height:28px;font-size:18px;text-align:center;">~</el-col>
                <el-col :span="11">
                  <el-form-item style="margin-bottom: 0;" prop="AfterQuantity">
                    <el-input size="mini" @blur="onBlur(data,'AfterQuantity')" @focus="onFocus(data,'AfterQuantity')" v-model="data.AfterQuantity" placeholder="输入数量"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运费" prop="FirstFreight">
              <el-input v-model="data.FirstFreight" @blur="onBlur(data,'FirstFreight')" @focus="onFocus(data,'FirstFreight')" placeholder="请输入运费"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="首件数量" prop="FirstQuantity">
              <el-input
                v-model="data.FirstQuantity"
                @blur="onBlur(data, 'FirstQuantity')"
                @focus="onFocus(data, 'FirstQuantity')"
                placeholder="请输入首件数量"
              ></el-input>
            </el-form-item>
            <el-form-item label="首件运费" prop="FirstFreight">
              <el-input
                v-model="data.FirstFreight"
                @blur="onBlur(data, 'FirstFreight')"
                @focus="onFocus(data, 'FirstFreight')"
                placeholder="请输入首件运费"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="继件数量" prop="AfterQuantity">
              <el-input
                v-model="data.AfterQuantity"
                @blur="onBlur(data, 'AfterQuantity')"
                @focus="onFocus(data, 'AfterQuantity')"
                placeholder="请输入继件数量"
              ></el-input>
            </el-form-item>
            <el-form-item label="继件运费" prop="AfterFreight">
              <el-input
                v-model="data.AfterFreight"
                @blur="onBlur(data, 'AfterFreight')"
                @focus="onFocus(data, 'AfterFreight')"
                placeholder="请输入继件运费"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10" style="margin-top: 20px" v-if="Condition == '1'">
          <el-col :span="12">
            <el-form-item label="首件重量" prop="FirstWeight">
              <el-input
                v-model="data.FirstWeight"
                @blur="onBlur(data, 'FirstWeight')"
                @focus="onFocus(data, 'FirstWeight')"
                placeholder="请输入首件重量"
              > <template slot="append">kg</template></el-input>
            </el-form-item>
            <el-form-item label="首件运费" prop="FirstFreight">
              <el-input
                v-model="data.FirstFreight"
                @blur="onBlur(data, 'FirstFreight')"
                @focus="onFocus(data, 'FirstFreight')"
                placeholder="请输入首件运费"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="继件重量" prop="AfterWeight">
              <el-input
                v-model="data.AfterWeight"
                @blur="onBlur(data, 'AfterWeight')"
                @focus="onFocus(data, 'AfterWeight')"
                placeholder="请输入继件重量"
              > <template slot="append">kg</template></el-input>
            </el-form-item>
            <el-form-item label="继件运费" prop="AfterFreight">
              <el-input
                v-model="data.AfterFreight"
                @blur="onBlur(data, 'AfterFreight')"
                @focus="onFocus(data, 'AfterFreight')"
                placeholder="请输入继件运费"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="金额范围" class="is-required">
              <el-row>
                <el-col :span="11">
                  <el-form-item style="margin-bottom: 0;" prop="FirstAmount">
                    <el-input size="mini" @blur="onBlur(data,'FirstAmount')" @focus="onFocus(data,'FirstAmount')" v-model="data.FirstAmount" placeholder="输入金额"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2" style="line-height:28px;font-size:18px;text-align:center;">~</el-col>
                <el-col :span="11">
                  <el-form-item style="margin-bottom: 0;" prop="AfterAmount">
                    <el-input size="mini" @blur="onBlur(data,'AfterAmount')" @focus="onFocus(data,'AfterAmount')" v-model="data.AfterAmount" placeholder="输入金额"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运费" prop="AmountFreight">
              <el-input v-model="data.AmountFreight" @blur="onBlur(data,'AmountFreight')" @focus="onFocus(data,'AmountFreight')" placeholder="请输入运费"></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  props: {
    Condition: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      data: {
        SupportId: 0,
        FreightId: null,
        ProvinceId: null, //省
        ProvinceName: "",
        CityId: null, //市
        CityName: "",
        DistrictId: null, //区
        DistrictName: "",
        FreightType: 1, //0:异地 1:本地
        FirstQuantity: 0, //异地：首件；本地：范围
        FirstFreight: 0, //异地：首件运费；本地：运费
        AfterQuantity: 0, //异地：继件；本地：范围
        AfterFreight: 0, //异地：继件运费
        FirstWeight: 0, //重量范围
        AfterWeight: 0, //重量范围
        AmountFreight: 0, //金额范围内运费
      },
      Districts: [],
      Select: [],
      api: require("@/api/sale/freightSupport").default,
      disApi: require("@/api/sale/district").default,
      rules: {
        FirstQuantity: [
          { required: true, message: "数量不能为空" },
          { validator: this.$commonJs.validateRules.int },
        ],
        FirstFreight: [
          { required: true, message: "运费不能为空" },
          { validator: this.$commonJs.validateRules.num },
        ],
        AfterQuantity: [
          { required: true, message: "数量不能为空" },
          { validator: this.$commonJs.validateRules.int },
        ],
        AfterFreight: [
          { required: true, message: "运费不能为空" },
          { validator: this.$commonJs.validateRules.num },
        ],
        FirstWeight: [
          { required: true, message: "金额范围不能为空" },
          { validator: this.$commonJs.validateRules.num },
        ],
        AfterWWeight: [
          { required: true, message: "金额范围不能为空" },
          { validator: this.$commonJs.validateRules.num },
        ],
        AmountFreight: [
          { required: true, message: "运费不能为空" },
          { validator: this.$commonJs.validateRules.num },
        ],
      },
    };
  },
  computed: {},
  methods: {
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0;
    },
    onFocus(row, type) {
      if (row[type] == 0) row[type] = null;
    },
    onCreateOpened(data) {
      this.UnSupport = data.UnSupport;
      console.log(data,"createopen");
      // var cityId = this.$store.state.user.cityId;
      var cityId = 1973;
      this.data.CityId = cityId;
      var filterIds = []; //不支持配送区域的省Id
      data.UnSupport.forEach((x) => {
        filterIds.push(x.DistrictId);
      });
      filterIds = filterIds.filter((x) => x != 0);
      this.disApi.list({ FindAreaCityId: cityId, filterIds }).then((res) => {
        res.Data = res.Data.filter((x) => x.Pid == cityId);
        this.Districts = res.Data.map((x) => {
          return { ...x, check: false };
        }); //获取当前企业市的区
        if(data.Counts.length>0){
           this.Districts.forEach((x)=>{
            data.Counts.forEach((item)=>{
              if(x.DistrictId==item.DistrictId){
                x.check=true
              }
            })
           })
        }
         if(data.Weights.length>0){
           this.Districts.forEach((x)=>{
            data.Weights.forEach((item)=>{
              if(x.DistrictId==item.DistrictId){
                x.check=true
              }
            })
           })
        }
      });
    },
    select(data) {
      if (!data.check) {
        console.log(data, "data");
        data.check = true;
        var ids = data.IdChain.split(".");
        var item = {
          Id: data.DistrictId, //区
          Name: data.Name,
          CityId: data.Pid,
          ProvinceId: Number(ids[0]),
        };
        console.log(item,"item");
        this.Select.push(item);
      }
    },
    remove(id, index) {
      var row = this.Districts.find((x) => x.DistrictId == id);
      row.check = false;
      this.Select.splice(index, 1);
    },
    onBeforeSave() {
      if (this.Select.length == 0) {
        this.$message.warning("请选择区县");
        return false;
      }
      var rows = this.Select.map((x) => {
        console.log(x,"select");
        return {
          SupportId: this.data.SupportId,
          FreightId: this.data.FreightId,
          ProvinceId: this.data.ProvinceId, //省
          CityId: this.data.CityId, //市
          DistrictId: x.Id, //区
          AreaName: x.Name,
          FreightType: 1, //0:异地 1:本地
          FirstQuantity: this.data.FirstQuantity, //异地：首件；本地：范围
          FirstFreight: this.data.FirstFreight, //异地：首件运费；本地：运费
          AfterQuantity: this.data.AfterQuantity, //异地：继件；本地：范围
          AfterFreight: this.data.AfterFreight, //异地：继件运费
          FirstWeight: this.data.FirstWeight, //金额范围
          AfterWeight: this.data.AfterWeight, //金额范围
          AmountFreight: this.data.AmountFreight, //金额范围内运费
          T: 0,
        };
      });

      // this.$refs.dialog.isLoading = true;
      // this.api.saveList(rows).then((res) => {
      //   if (res.Code == 0) {
      //     this.$emit("detail-save", res.Data);
      //     this.close(true);
      //   } else {
      //     this.$message.error("保存失败");
      //   }
      //   this.$refs.dialog.isLoading = false;
      // });
      console.log(rows, "innercity add");
      this.$emit("detail-save", rows);
      this.close(true);
      return false;
    },
    onClosed() {
      this.Districts = [];
      this.Select = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.citys-head {
  width: 100%;
  line-height: 40px;
  font-size: 14px;
  font-weight: bold;
  padding-left: 10px;
  border: 1px solid #ebeef5;
  border-bottom: none;
}
.citys-box {
  overflow-y: auto;
  border: 1px solid #ebeef5;
  .item {
    line-height: 40px;
    font-size: 16px;
    width: 100%;
    display: inline-block;
    padding-left: 10px;
    cursor: default;
    .close-btn {
      float: right;
      line-height: 40px;
      margin-right: 13px;
      color: #7b7b7b;
    }
    .btn-box {
      float: right;
      margin-right: 10px;
      .btn {
        font-size: 22px;
        width: 50px;
        padding: 0 !important;
        height: 24px;
        text-align: center;
        transform: translateY(4px);
      }
    }
  }
  .item:hover {
    background-color: #eefff9;
  }
}
</style>